export enum VALIDATION_ERROR_MESSAGES {
    SAME_LOT_OR_EMPTY_NAME = 'We couldn’t save because one or more of the lots is either missing a name or has a duplicate name. Please ensure all lots have unique names and try again.'
}
